import { ChangeDetectionStrategy, Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IonNav } from '@ionic/angular';
import { NavigationService, ChildNavNames, PageName } from '../../../services/navigation/navigation.service';
import { UIService } from '../../../services/ui/ui.service';
import { DeviceService } from '../../../services/device/device.service';
import { FooterService } from '../../../services/footer/footer.service';
import { AgendaFooterService } from '@omni/services/footer/agenda-footer.service';
import { MedicalInsightService } from '@omni/services/medical-insight/medical-insight-service';

/**
 * Generated class for the MedicalInsightPageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'medical-insight-page[base-page]',
  templateUrl: 'medical-insight-page.html',
  styleUrls:['medical-insight-page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MedicalInsightPageComponent {
  private readonly _quickCreateDestroy$ = new Subject<void>();

  @ViewChild('medicalinsightpagerightpane', {static:true}) public navCtrl: IonNav;

  constructor(
    private readonly _quickCreateCd: ChangeDetectorRef,
    public navService: NavigationService,
    public uiService: UIService,
    public device: DeviceService,
    private footerService: FooterService,
    public agendaFooterService: AgendaFooterService,
    private readonly medicalInsightService: MedicalInsightService,
  ) {
  }

  ngOnInit() {
    // The template reads isActiveChildNavRightPaneViewDisplayed directly, but OnPush means
    // a pushed page (a quick-created meeting) flips the flag with nothing to repaint on.
    this.navService.childNavRightPaneView$.pipe(
      takeUntil(this._quickCreateDestroy$))
      .subscribe(() => {
        this._quickCreateCd.detectChanges();
      });
    this.navService.initRightPaneChildNav(this.navCtrl, ChildNavNames.MedicalInsightPageNavigation, PageName.MedicalInsightPageComponent, false, {deviceString: this.device.deviceFlags.ios ? 'ios' : 'other'});
    this.footerService.initButtons('');
  }

  ionViewDidEnter() {
  }

  public isSplitView(): boolean {
    return (window.innerWidth > 500);
  }

  ngOnDestroy(){
    this._quickCreateDestroy$.next();
    this._quickCreateDestroy$.complete();
    // this.agendaFooterService.initButtons(this.agendaFooterService.footerViewAtHome);
    // this.agendaFooterService.footerViewAtHome = null;
    this.medicalInsightService.myMedicalInsights = [];
    this.navService.popChildNavCtrlFromStack(ChildNavNames.MedicalInsightPageNavigation);
  }

}
